export const TITLE = 'The job is complete & signed-off';

export const INTRODUCED_TITLE = 'The order is complete & signed-off';
